export enum NotificationTypes {
    notification = 0,
    alert = 1,
}